import { render, staticRenderFns } from "./RankEditor.vue?vue&type=template&id=88281e2e&scoped=true&"
import script from "./RankEditor.vue?vue&type=script&lang=js&"
export * from "./RankEditor.vue?vue&type=script&lang=js&"
import style0 from "./RankEditor.vue?vue&type=style&index=0&id=88281e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88281e2e",
  null
  
)

export default component.exports